export default __webpack_public_path__ + "static/media/about_bg.8a7aae7b.png";